export default "__VITE_ASSET__DY8i2caT__"